module.exports = __webpack_public_path__ + "img/DESIGNSINGAPORE COUNCIL PTE. LTD - cropped..ae2e8d36.png";